import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { classicEbook, readySystem } from '../../data/content';
export function DifferenceSection() {
  return <section aria-labelledby="difference-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-80" data-mp="2ajoehlxm6b7p">
      <div className="mx-auto max-w-5xl" data-id="element-81" data-mp="2fc7u0ofv3gf5">
        <SectionHeading id="difference-heading" title="Ce n’est pas simplement du contenu à lire." data-id="element-82" data-mp="2kaj4n1dzduyf" />

        <div className="mt-12 grid items-stretch gap-5 md:grid-cols-[2fr_3fr]" data-id="element-83" data-mp="2oc4aw3w0fazn">
          <div className="rounded-[20px] bg-brand-paper p-7 sm:p-9" data-id="element-84" data-mp="2oe7btiypaoj5">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-85" data-mp="2tcil9sl32x0u">
              Un ebook classique
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-86" data-mp="yxps007oaic2">
              {classicEbook.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-87" data-mp="13vrbuncxalol">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-88" data-mp="39pusk6kf9ynu" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-89" data-mp="2zzt3bbgc2a7c">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-90" data-mp="2vvlbh5ekwe4w">
              Nail Educator Ready™
            </h3>
            <ul className="mt-6 grid gap-x-6 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-91" data-mp="3npvtfm0ot63b">
              {readySystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-92" data-mp="3jl60a4xey5m3">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-93" data-mp="287u2aaoc4h7u" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-14 text-center font-display text-[2.2rem] font-bold leading-none text-brand-charcoal sm:text-[3rem]" data-id="element-94" data-mp="24pms4y9qwukr">
          Ouvrez. Choisissez. <Accent data-id="element-95" data-mp="29mwqj3f44gkq">Enseignez.</Accent>
        </p>
      </div>
    </section>;
}